export type EvChargingScheduleSetpoint = {
    timestamp: string
    power: number
}

export type EvChargingChargingWindow = {
    start: string
    end: string
    setpoints: EvChargingScheduleSetpoint[]
}

export type EvChargingLimitationWindow = {
    start: string
    end: string
    reason: string | null
}

export type EvChargingSchedule = {
    resolution: string
    hash: string
    chargingWindows: EvChargingChargingWindow[]
    limitationWindows?: EvChargingLimitationWindow[]
}

export type EvChargingSession = {
    id: number
    deviceId: number
    locationId: number
    evseStatus: string
    isEvConnected: boolean
    isClosed: boolean
    closedAt: string | null
    closeReason: string | null
    initialSoc: number | null
    targetSoc: number | null
    arrivalAt: string | null
    departureAt: string | null
    targetReachedAt: string | null
    evBatteryCapacityMax: number | null
    optimizeForCost: boolean
    energyDelivered: number
    chargingCost: number | null
    currency: string
    schedule: EvChargingSchedule | null
    metadata?: { forecastRequestId?: string | null } | null
    createdAt: string
    updatedAt: string
}

export type EvChargingPricePoint = {
    from: string
    to: string
    supplierEnergyBuyTotal?: { amount: string } | null
}

export enum EvChargingLoadingTypes {
    SESSIONS = "SESSIONS",
    SESSION = "SESSION",
    UPDATE_SESSION = "UPDATE_SESSION",
    PRICES = "PRICES",
    REALTIME_POWER = "REALTIME_POWER",
}

export type EvChargingState = {
    sessions: EvChargingSession[]
    currentSession: EvChargingSession | null
    prices: EvChargingPricePoint[]
    realtimePowerW: number | null
    loading: Record<EvChargingLoadingTypes, boolean>
}

export type EvChargingSessionsApiResponse = {
    data: EvChargingSession[]
    total: number
    limit: number
    offset: number
}

export type EvChargingSessionApiResponse = {
    data: {
        session: EvChargingSession
    }
}
